export const AUDIENCE_NAMES = {
    participants: "User",
    facilitators: "Facilitator",
    admins: "Admin",
};
/** Match the selected reading audience; administrator guides are admin-only. */
export function matchesAudience(article, audience) {
    if (article.domainId === "admin")
        return audience === "admins";
    return article.audiences.includes(audience === "admins" ? "participants" : audience);
}
/** Exclude admin-only guides unless the caller has verified tenant-admin access. */
export function allowedKnowledgeArticles(articles, canViewAdmin = false) {
    return articles.filter((article) => canViewAdmin ||
        (article.domainId !== "admin" && !article.audiences.includes("admins")));
}
/** Preserve the selected reading audience when linking between Library pages. */
export function audiencePath(path, audience) {
    return path + "?audience=" + audience;
}
//# sourceMappingURL=audience.js.map